var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#77928B"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1102.839 44.615V45c-.225 0-.44-.083-.6-.233-.316-.3-.32-.779-.008-1.083l3.773-3.684-3.773-3.684c-.311-.304-.308-.783.009-1.083.332-.314.88-.31 1.206.009l4.324 4.221c.307.3.307.773 0 1.074l-4.324 4.22c-.159.156-.378.243-.607.243v-.385z",
    transform: "translate(-1330 -645) translate(230 185) translate(0 423) rotate(90 1105 40)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoForward);
export default __webpack_public_path__ + "static/media/ico-forward.bf833ca0161058ee20d853a332f19df7.svg";
export { ForwardRef as ReactComponent };